export const ICON_CONSTANTS = {
  NON_RETURNABLE_BLACK_NEW: 'NON_RETURNABLE_BLACK_NEW',
  NON_RETURNABLE_BLACK: 'NON_RETURNABLE_BLACK',
  INSTALLMENTS: 'INSTALLMENTS',
  INSTALLMENTS_NEW: 'INSTALLMENTS_NEW',
  INSTALLMENTS_OLD: 'INSTALLMENTS_OLD',
  DISCOUNT_ICON: 'DISCOUNT_ICON',
  DISCOUNT_ICON_GREEN: 'DISCOUNT_ICON_GREEN',
  EDIT_ICON: 'EDIT_ICON',
  RECURRING_ICON: 'RECURRING_ICON',
  RECURRING_ICON_BLACK: 'RECURRING_ICON_BLACK',
  LOCK_ICON: 'LOCK_ICON',
  SHIELD_ICON: 'SHIELD_ICON',
  WARRANTY_ICON: 'WARRANTY_ICON',
} as const

export const ICON_CONSTANTS_MAP: Record<keyof typeof ICON_CONSTANTS, string> = {
  [ICON_CONSTANTS.NON_RETURNABLE_BLACK_NEW]:
    'https://images.quince.com/3E3SxLDx3RwHCjQUxCn3Ip/815ab061c73c49c8bc87d0a949e163ef/nonReturnableBlackNew.inline.svg',
  [ICON_CONSTANTS.NON_RETURNABLE_BLACK]:
    'https://images.quince.com/RsgvVf4vhnazdnB6JiAi0/c1af2f8ee61783ab2dbb66fa9b621b39/nonReturnableBlack.inline.svg',
  [ICON_CONSTANTS.INSTALLMENTS]:
    'https://images.quince.com/31scCSt4NU4D7aoZfiFRsf/0486eab285d15ea0f16bf01812aeffd6/calendar.svg',
  [ICON_CONSTANTS.INSTALLMENTS_NEW]:
    'https://images.quince.com/34JZxkTOluudT4nusYJWIJ/4c618ada988a7ea5121506ba10cf1b6c/installments.svg',
  [ICON_CONSTANTS.INSTALLMENTS_OLD]:
    'https://images.quince.com/778e2RRUg6qVuvglcNZcAy/5edb3d36d0a261f6302ffa3100c7fdf5/installments.inline.svg',
  [ICON_CONSTANTS.DISCOUNT_ICON]:
    'https://images.quince.com/22t6UBvCWC0aztl55XCbgB/fcf420623907c3d6ca6f0b94ac4d1862/discountIcon.inline.svg',
  [ICON_CONSTANTS.DISCOUNT_ICON_GREEN]:
    'https://images.quince.com/7FUyQHHwMoHyMAbic3Zkhj/73d333ecf09af59a4273c425a5c15fbb/discountIconGreen.inline.svg',
  [ICON_CONSTANTS.EDIT_ICON]:
    'https://images.quince.com/40MGOb1PZO3kEqpCqpb47S/b1437a3fbe6aba403cc1fa3a63362957/editIcon.inline.svg',
  [ICON_CONSTANTS.RECURRING_ICON]:
    'https://images.quince.com/hBWWly6kefRX7y5gaBTZK/5c067d7290d35e11fbc0910f984617aa/recurringIcon.inline.svg',
  [ICON_CONSTANTS.RECURRING_ICON_BLACK]:
    'https://images.quince.com/1yfMSrWY7UVJZ8dv06Bd9b/9cc7a69c5aa483d0caef586e2f968246/recurringIconBlack.inline.svg',
  [ICON_CONSTANTS.LOCK_ICON]:
    'https://images.ctfassets.net/afruo3gr1g6h/6g4gEKiDJalao7rAWxZNfE/aafceabfeffc7dfb18e431a4828682ae/lock.inline.svg',
  [ICON_CONSTANTS.SHIELD_ICON]:
    'https://images.ctfassets.net/afruo3gr1g6h/1B4dDEk1SDORYJvdAoZV43/4730bcf3f9e9c56c85e687bb6c6439d5/shield.inline.svg',
  [ICON_CONSTANTS.WARRANTY_ICON]:
    'https://images.ctfassets.net/afruo3gr1g6h/2NX3yRsY5RSf6IqR5iuVRO/bfb5e0c7cda831b84ca12c114bef0304/warranty.inline.svg',
} as const
